// .mjs file is a JavaScript module file that uses ECMAScript Modules (ESM).

import { Feature, Map, Overlay, View, Geolocation, Observable } from 'ol';
import { containsCoordinate, getCenter } from 'ol/extent.js';
import { Tile, Vector, Image, Group, VectorImage} from 'ol/layer.js';
import { Fill, RegularShape, Stroke, Style, Text, Icon, Circle as CircularStyle} from 'ol/style.js';
import { XYZ, TileWMS, ImageWMS, Vector as VectorSource, Image as ImageSource, ImageStatic, OSM, TileArcGISRest} from 'ol/source.js';
import { defaults, OverviewMap, MousePosition, Control, ScaleLine, Zoom, Attribution, FullScreen} from 'ol/control.js';
import { fromLonLat, transformExtent, transform, toLonLat, addProjection, Projection, get, getPointResolution } from 'ol/proj.js';
import * as proj444 from 'ol/proj/proj4.js';
import * as units from 'ol/proj/Units.js';
import { Circle, LineString, MultiPoint, Point, MultiPolygon, Polygon } from 'ol/geom.js';
import * as PolygonExt from 'ol/geom/Polygon.js';
import { Snap, Select, Draw, Translate, defaults as defaultsInt, Modify} from 'ol/interaction.js';
import { GeoJSON, WKT, KML, EsriJSON} from 'ol/format.js';
import { toStringHDMS, toStringXY, createStringXY} from 'ol/coordinate.js';
import { getArea, getLength, getDistance} from 'ol/sphere.js';
import * as condition from 'ol/events/condition.js';
import { destination, greatCircle, union, intersect, circle, bearing, helpers, distance, cleanCoords, simplify } from '@turf/turf';
import { featureCollection, point, polygon } from "@turf/helpers";
import {unByKey} from 'ol/Observable.js';
import proj44 from 'proj4';
import ContextMenu from 'ol-contextmenu';

import Measure from './measure-tool.js';
import { GeomUtils } from './geom-utils.js';
import { getVectorContext } from 'ol/render.js';
import { createRegularPolygon } from 'ol/interaction/Draw.js';
import LayerSwitcher from 'ol-layerswitcher';



// Merge default and named exports
const PolygonCombined = Object.assign(Polygon, PolygonExt);

const ol = {

    Map, View, Feature, Overlay, Geolocation, Measure, GeomUtils: GeomUtils, 
    geom:{
        Point, LineString, Polygon: PolygonCombined, MultiPolygon, MultiPoint, Circle
    },    
    layer: {
        Image, Tile, Vector, Group, VectorImage 
    },    
    source: {
        ImageStatic, OSM, XYZ, Vector: VectorSource,  TileWMS, Image: ImageSource, ImageWMS, TileArcGISRest   
    },  
    style: { 
        RegularShape, Style, Fill, Stroke, Circle: CircularStyle, Icon, Text
    },    
    control:{
        MousePosition, Control, defaultControls: defaults, defaults, ScaleLine, OverviewMap, Zoom, Attribution, LayerSwitcher, FullScreen
    },    
    events: { 
        condition 
    },
    interaction:{
        defaults: defaultsInt, Draw, Select, Snap, Translate, Modify, createRegularPolygon
    },
    coordinate:{
        toStringHDMS, toStringXY, createStringXY
    },
    Observable:{
        unByKey
    },
    sphere: { 
        getArea, getLength, getDistance 
    },
    render:{
        getVectorContext
    },
    format:{
        GeoJSON, WKT, EsriJSON, KML
    },
    extent: {
        getCenter, containsCoordinate
    },
    proj: {
        transform, transformExtent, fromLonLat, toLonLat, getPointResolution, units,
        addProjection,
        get,
        Projection,
        proj4: proj444        
    },
    ContextMenu    
};

const proj4 = proj44;

const turf = {
    intersect, greatCircle, circle, destination, bearing, union, helpers, distance, point, polygon, featureCollection, cleanCoords, simplify
};

export default {ol, proj4, turf};

